<template>
  <v-container class="overview-page">

    <v-row class="ma-0">
      <v-col cols="12">
        <h2 class="primary--text font-weight-bold pt-5 pl-2">
          <v-icon color="primary" large left>account_tree</v-icon>
          {{ $t('book/admin:facility-type.common.type_plural') }}

        </h2>

        <DataTable
            :headers="headers"
            :data="content"
            icon="edit"
            @clickedButton1="$router.push(`/${$store.state.manager.bookModuleUrl}/admin/facility-type/edit/${$event.id}`)"
            addBtn
            :addBtnRoute="`/${$store.state.manager.bookModuleUrl}/admin/facility-type/edit`"
            :addBtnText="$t('buttons:add-specific', { specific: $t('book/admin:facility-type.common.type')})"
            sortBy="name"
            enabledSearch
            @cacheCommit="$store.commit('book/admin/storeFacilityTypesOverviewSearch', $event)"
            :cachedSearch="$store.state.book.admin.facilityTypesOverviewSearch"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import FacilityTypeService from "@/modules/book/services/facility-type-service";

import DataUtils from "@/modules/core/services/data-utils";
import Utils from "@/modules/core/services/utils";

import FacilityType from "@/modules/book/data/facility-type";

import DataTable from "@/modules/core/components/DataTable/DataTable";

export default {
  name: "FacilityTypeOverview",
  components: {
    DataTable
  },
  data() {
    return {
      content: []
    }
  },
  computed: {
    headers() {
      return [
        {text: 'ID', value: 'id'},
        {text: this.$t('common:name'), value: 'name'},
        {text: this.$t('common:description'), value: 'description'},
        {text: '', value: 'controls', sortable: false}
      ]
    }
  },
  created() {
    FacilityTypeService.readAllFromAPI(
      (res) => {
        this.content = DataUtils.parseDataToObjectArray(res.data, FacilityType);
      },
      (error) => {
        Utils.showFailureSnackbar(this.$t('snackbar:load-failure', {name: this.$t('book/admin:facility-type.common.type_plural')}))
        this.$logger.error(error);
      }
    )
  }
}
</script>